"use client";

import styles from "@/styles/home/quick-menu.module.scss";
import Image from "next/image";
import { Arrow } from "@react-vant/icons";

interface MenuItem {
  title: string;
  href: string;
  image: string;
  backgroundImage: string;
  description: string;
}

export default function QuickMenu() {
  const MenuList: MenuItem[] = [
    {
      title: "New Arrivals",
      href: "/new-arrivals",
      image: `${process.env.IMAGE_DOMAIN}/home/quick-menu/NewArrivals-icon.svg`,
      backgroundImage: `${process.env.IMAGE_DOMAIN}/home/quick-menu/NewArrivals-bg.png`,
      description: "New products and show item",
    },
    {
      title: "Best Deals",
      href: "/bestseller",
      image: `${process.env.IMAGE_DOMAIN}/home/quick-menu/BestDeals-icon.svg`,
      backgroundImage: `${process.env.IMAGE_DOMAIN}/home/quick-menu/BestDeals-bg.png`,
      description: "Popular Products & Best Deals",
    },
    {
      title: "Free Shipping",
      href: "/free-shipping",
      image: `${process.env.IMAGE_DOMAIN}/home/quick-menu/FreeShipping-icon.svg`,
      backgroundImage: `${process.env.IMAGE_DOMAIN}/home/quick-menu/FreeShipping-bg.png`,
      description: "Free delivery to save money",
    },
    {
      title: "Clearance",
      href: "/clearance",
      image: `${process.env.IMAGE_DOMAIN}/home/quick-menu/Clearance-icon.svg`,
      backgroundImage: `${process.env.IMAGE_DOMAIN}/home/quick-menu/Clearance-bg.png`,
      description: "Clearance Products",
    },
  ];

  const handleViewDetail = (cate: MenuItem) => {
    if (!cate.href) return;
    window.location.href = cate.href;
  };

  return (
    <div className={styles["comp-quick-menu"]}>
      <div className={styles["quick-menu-list"]}>
        {MenuList.map((cate: MenuItem) => (
          <div 
            key={cate.title}
            className={styles["quick-menu-item"]} 
            style={{ backgroundImage: `url(${cate.backgroundImage})` }}
            onClick={() => handleViewDetail(cate)}
          >
            <Image
              className={styles["quick-menu-icon"]}
              src={cate.image}
              alt={cate.title}
              width={42}
              height={42}
              priority={true}
            />

            <div className={styles["item-content"]}>
              <div className={styles["content-info"]}>
                <div className={styles["quick-menu-name"]}>{cate.title}</div>
                <div className={styles["quick-menu-desc"]}>{cate.description}</div>
              </div>
              <Arrow className={styles["arrow-icon"]} fontSize={"20px"} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
